
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexIwuvNo69Vgf5xQ1ImynGaee3sc7rPtCQ71OW5x5ZSy0Meta } from "/codebuild/output/src1209217879/src/zazos-web/pages/index.vue?macro=true";
import { default as indexV3jGDA5uvpdXorp_45d0lsQjD2zWAriOtkKn1BP1Z_45814Meta } from "/codebuild/output/src1209217879/src/zazos-web/pages/login/index.vue?macro=true";
import { default as set_45workspace4O90bX9OIzNIripS9tVNZ9C5Dk4FFrh9boe37JK_7PgMeta } from "/codebuild/output/src1209217879/src/zazos-web/pages/set-workspace.vue?macro=true";
import { default as indexaVHeUfwn_45awFKRR_45p3XSHKOky1ECCVReBjTAY1UJiEsMeta } from "/codebuild/output/src1209217879/src/zazos-web/pages/sign-up/index.vue?macro=true";
import { default as indexgY_45MUZ07HLTc0hL0XYfq9LNRJaNOt8I02iGBOG2aObMMeta } from "/codebuild/output/src1209217879/src/zazos-web/pages/magic-link/index.vue?macro=true";
import { default as indexMN9A0xB7oVy5HHBQA3EQBE4CBHkfK8_YOMgsEu6kh5EMeta } from "/codebuild/output/src1209217879/src/zazos-web/pages/t/[tenantSlug]/m/index.vue?macro=true";
import { default as indexjxfMYrRtkQatPba6Tc_45KEkjoG5rLyodTg60WjUZZZBIMeta } from "/codebuild/output/src1209217879/src/zazos-web/pages/t/[tenantSlug]/m/[viewId]/index.vue?macro=true";
import { default as newIGbSdZxR4dkVm_1TKWvQVNY3qTFRjJe7jhaLs0vbohgMeta } from "/codebuild/output/src1209217879/src/zazos-web/pages/t/[tenantSlug]/m/[viewId]/r/new.vue?macro=true";
import { default as account_45configurationE1OWhjOkMSDAIERvSeHtiQctf3sIzH8r9fE_D3w0X8wMeta } from "/codebuild/output/src1209217879/src/zazos-web/pages/t/[tenantSlug]/m/account-configuration.vue?macro=true";
import { default as index50FQpVPrmguhNaYAXyO1WljXaLD4ycJWsc2IsY8V01wMeta } from "/codebuild/output/src1209217879/src/zazos-web/pages/t/[tenantSlug]/m/[viewId]/r/[recordId]/index.vue?macro=true";
import { default as mTibwoLj6aNzFLTlPwnvmQHA8OJJqpgre00S_QxQeD7AMeta } from "/codebuild/output/src1209217879/src/zazos-web/pages/t/[tenantSlug]/m.vue?macro=true";
import { default as indexY7aBcFsmE5MYlwYBZcX6TWyQEl_4515VPB_45QRN_V0hIR0Meta } from "/codebuild/output/src1209217879/src/zazos-web/pages/reset-password/index.vue?macro=true";
import { default as indexqDdf3swLYVJt34T_45klzncHoxtnw_Ifpb2wkpYvArb_45YMeta } from "/codebuild/output/src1209217879/src/zazos-web/pages/t/[tenantSlug]/index.vue?macro=true";
import { default as index7urEnW_453JLCZoL1JdfQpxQOTdJ4So_45cBVA7vg_gWFjEMeta } from "/codebuild/output/src1209217879/src/zazos-web/pages/t/[tenantSlug]/studio/index.vue?macro=true";
import { default as indexRXB55rM5URKie7LQcuuS8wj7GObvoJq2Yiwp_p5ZKtkMeta } from "/codebuild/output/src1209217879/src/zazos-web/pages/t/[tenantSlug]/studio/settings/index.vue?macro=true";
import { default as user_45signup9iQA8I6I_UkMSKFV4lovLnoXoCmOOpF5tXr_45Uf2imCkMeta } from "/codebuild/output/src1209217879/src/zazos-web/pages/t/[tenantSlug]/studio/settings/user-signup.vue?macro=true";
import { default as indexDcXQku5SODY9hFj6qV2NaI9NMdS0kv0o7myhvBk6SvEMeta } from "/codebuild/output/src1209217879/src/zazos-web/pages/t/[tenantSlug]/studio/settings/users/index.vue?macro=true";
import { default as index_45Q2J_gdJowgn5zK1Z6Qcx0U1lDaGmSgGLLrMRAEDOYoMeta } from "/codebuild/output/src1209217879/src/zazos-web/pages/t/[tenantSlug]/studio/settings/tokens/index.vue?macro=true";
import { default as index0yjAQpJP3KBLsT5W6UMcCtGahMTp7_Ri8QpC7ibTupkMeta } from "/codebuild/output/src1209217879/src/zazos-web/pages/t/[tenantSlug]/studio/settings/internal/index.vue?macro=true";
import { default as newJoaV_1E4ubzjDSoa9PvSFFxxJ9NeVsdh_d4pQGxoGHIMeta } from "/codebuild/output/src1209217879/src/zazos-web/pages/t/[tenantSlug]/studio/settings/user-groups/new.vue?macro=true";
import { default as _91id_93sW3TClH_yPmYzD8Eta3CVfAN4Nk8ZDndxzFCCxaC21gMeta } from "/codebuild/output/src1209217879/src/zazos-web/pages/t/[tenantSlug]/studio/settings/user-groups/[id].vue?macro=true";
import { default as indexE66FVutG_45d_4PubgNbp_45vBCHuWk1EKpxXZQ_45GykpY08Meta } from "/codebuild/output/src1209217879/src/zazos-web/pages/t/[tenantSlug]/studio/settings/app-builder/index.vue?macro=true";
import { default as indexiUZE9KTE1PnzKYw54_x_458EjlRvuki_rysJtz6_45p_1GAMeta } from "/codebuild/output/src1209217879/src/zazos-web/pages/t/[tenantSlug]/studio/settings/export-data/index.vue?macro=true";
import { default as indexwrrktXG5xxWxBtdsjwxEQruyrCSodHl04u39O5tHwKEMeta } from "/codebuild/output/src1209217879/src/zazos-web/pages/t/[tenantSlug]/studio/settings/user-groups/index.vue?macro=true";
import { default as index03RMBaoCdFQsFr_453fc1bvQuXly3zFU8HYPOlsBw9pbwMeta } from "/codebuild/output/src1209217879/src/zazos-web/pages/t/[tenantSlug]/studio/settings/integrations/index.vue?macro=true";
import { default as indexUPVHK8h6TQxEa3As0o2RBfJidKsEgTpxt_457Ewv2rTRwMeta } from "/codebuild/output/src1209217879/src/zazos-web/pages/t/[tenantSlug]/studio/settings/authentication/index.vue?macro=true";
import { default as indexwZ12LQl_jGvSaAF1SzUtnUE8sZAfWjNeQqR3PBe8VW8Meta } from "/codebuild/output/src1209217879/src/zazos-web/pages/t/[tenantSlug]/studio/settings/email-analytics/index.vue?macro=true";
import { default as indexCjT5KuGM8m67JjNU9NKm_Gmh5j1Z_4532MBwPfKVamYEcMeta } from "/codebuild/output/src1209217879/src/zazos-web/pages/t/[tenantSlug]/studio/settings/system-entities/index.vue?macro=true";
import { default as _91providerSlug_93Ba_45BimnWI31poC1VMXXqQjT35kGX6lXrGTZYKBuo_d4Meta } from "/codebuild/output/src1209217879/src/zazos-web/pages/t/[tenantSlug]/studio/settings/integrations/[providerSlug].vue?macro=true";
import { default as indexS446lBwt_nnAANd313Su9VG7vFJiCMoOXP5nzMNBedkMeta } from "/codebuild/output/src1209217879/src/zazos-web/pages/t/[tenantSlug]/studio/settings/global-parameters-manager/index.vue?macro=true";
import { default as settingsr6up_WUy0XMiRyL2VoGU8lclUrZcgB528EKyJSsjel4Meta } from "/codebuild/output/src1209217879/src/zazos-web/pages/t/[tenantSlug]/studio/settings.vue?macro=true";
import { default as indexWKQa1AxMgmTrqCzNwCthRCdTApHZUr9j6rzpUO2cIkIMeta } from "/codebuild/output/src1209217879/src/zazos-web/pages/t/[tenantSlug]/studio/data/index.vue?macro=true";
import { default as _91id_93fwqpHg9kHvM_Ip1ERamo3Y0F54V8mhBWTRcyoAkumCoMeta } from "/codebuild/output/src1209217879/src/zazos-web/pages/t/[tenantSlug]/studio/pages/[id].vue?macro=true";
import { default as indexpde8atSaliiuj6PsPA_bzBY6Y18aE_4hoS3Bl8juHXIMeta } from "/codebuild/output/src1209217879/src/zazos-web/pages/t/[tenantSlug]/studio/pages/index.vue?macro=true";
import { default as indexQTAc7vpE_455ZB_xKG7tGEKOjwAitQyjpy36WbOTHR39wMeta } from "/codebuild/output/src1209217879/src/zazos-web/pages/t/[tenantSlug]/studio/data/[id]/index.vue?macro=true";
import { default as importS_NwRwIMhHKvd6S5JbSaPuC6IySGubZwrJpGKvznQicMeta } from "/codebuild/output/src1209217879/src/zazos-web/pages/t/[tenantSlug]/studio/data/[id]/import.vue?macro=true";
import { default as schemaz3sH4ts1dYp_RjNWAmbvqAZth_458l9spHkxGQOdO7cZkMeta } from "/codebuild/output/src1209217879/src/zazos-web/pages/t/[tenantSlug]/studio/data/[id]/schema.vue?macro=true";
import { default as indeximGZ_Cq76_Lt52yNMFNs9BlQRZ_45k258pHXrw97OmSXAMeta } from "/codebuild/output/src1209217879/src/zazos-web/pages/t/[tenantSlug]/studio/automations/index.vue?macro=true";
import { default as indexLBs1GUAlGAb45OdjF__45DLDcVVKp6WUI5co7xfZhtflQMeta } from "/codebuild/output/src1209217879/src/zazos-web/pages/t/[tenantSlug]/studio/automations/[id]/index.vue?macro=true";
import { default as historyMQ5KaA9LyMKOVgseAJ_458kxZymKPvnqfO5NkCm0X8ftIMeta } from "/codebuild/output/src1209217879/src/zazos-web/pages/t/[tenantSlug]/studio/automations/[id]/history.vue?macro=true";
import { default as studiov5o_xyD9LldRiiK1Aq5lbAnAZ_hS3LXilkUYMOZNw7EMeta } from "/codebuild/output/src1209217879/src/zazos-web/pages/t/[tenantSlug]/studio.vue?macro=true";
import { default as indexqC_45WZFkeMPs6vPH5HFC5lQv_KxBfM20utPGtwXaCXEcMeta } from "/codebuild/output/src1209217879/src/zazos-web/pages/t/[tenantSlug]/p/index.vue?macro=true";
import { default as index3ICLVicQ_gFr31vVbQ0DIeU4XQQmP6J7oSvnOysToDsMeta } from "/codebuild/output/src1209217879/src/zazos-web/pages/t/[tenantSlug]/mfa/index.vue?macro=true";
import { default as index6k_mimgEnpM6dp8_PbqGmWFDYVH_3_45SjZTV2xFP4AMIMeta } from "/codebuild/output/src1209217879/src/zazos-web/pages/t/[tenantSlug]/login/index.vue?macro=true";
import { default as index8GIW8XcWnxOEQaHOpmucC0lsVTYijBPXshQyOgHggfUMeta } from "/codebuild/output/src1209217879/src/zazos-web/pages/t/[tenantSlug]/store/index.vue?macro=true";
import { default as _91app_937OU2ev9Iyqw757sFOxpE1AIHxdOufMkWxvEVqluDh4QMeta } from "/codebuild/output/src1209217879/src/zazos-web/pages/t/[tenantSlug]/install/[app].vue?macro=true";
import { default as indexEj3WjLzr3Rt78aLpx32EIGB0XxH6aPdNer9eaYasw54Meta } from "/codebuild/output/src1209217879/src/zazos-web/pages/t/[tenantSlug]/loading/index.vue?macro=true";
import { default as index8fmkW7b9jnm7mz52NUJTKaQOgg3zAqRiJl9l1cjCpIwMeta } from "/codebuild/output/src1209217879/src/zazos-web/pages/t/[tenantSlug]/sign-up/index.vue?macro=true";
import { default as reset_45password40TLFf3FjNw9ksarMo51_45PD961D5cMPCPGbGiq1Ozd0Meta } from "/codebuild/output/src1209217879/src/zazos-web/pages/t/[tenantSlug]/reset-password.vue?macro=true";
import { default as indexzEnj68N0rjiByVXJD0WKamEt6qSIcR0gw5osz02wFdAMeta } from "/codebuild/output/src1209217879/src/zazos-web/pages/t/[tenantSlug]/sso/saml/index.vue?macro=true";
import { default as indexnPyT4c_vU0v0KtaiUW1MA4NdpSET2OtjOOxP7EgsbtQMeta } from "/codebuild/output/src1209217879/src/zazos-web/pages/t/[tenantSlug]/mfa/setup/index.vue?macro=true";
import { default as indexWOmcwDgSF2a12WxPEPBbzv2UdN0E_3noeGJ3cR2IrIAMeta } from "/codebuild/output/src1209217879/src/zazos-web/pages/t/[tenantSlug]/p/[viewId]/index.vue?macro=true";
import { default as _91appName_93g0MfvHqhCI4ILPPRLehvxttp0vvteA6HcPR_5VxHoF4Meta } from "/codebuild/output/src1209217879/src/zazos-web/pages/t/[tenantSlug]/store/apps/[appName].vue?macro=true";
import { default as indexLzWxp2caG2VTUsqV_ius_45uRWLqt5IvwCwHJB34enpkoMeta } from "/codebuild/output/src1209217879/src/zazos-web/pages/t/[tenantSlug]/install/-review/index.vue?macro=true";
import { default as indexvYOa3CXosubg6hXdZgNCg27jpqeTfZvDiejDnq_45QBIcMeta } from "/codebuild/output/src1209217879/src/zazos-web/pages/t/[tenantSlug]/email-validation/index.vue?macro=true";
import { default as indexD0k_456D9ab5fn9avCIbTgY91x0JmsoF0sxpDYPjbxZ5kMeta } from "/codebuild/output/src1209217879/src/zazos-web/pages/t/[tenantSlug]/p/[viewId]/r/[recordId]/index.vue?macro=true";
export default [
  {
    name: "index___en",
    path: "/en",
    meta: indexIwuvNo69Vgf5xQ1ImynGaee3sc7rPtCQ71OW5x5ZSy0Meta || {},
    component: () => import("/codebuild/output/src1209217879/src/zazos-web/pages/index.vue")
  },
  {
    name: "index___pt",
    path: "/",
    meta: indexIwuvNo69Vgf5xQ1ImynGaee3sc7rPtCQ71OW5x5ZSy0Meta || {},
    component: () => import("/codebuild/output/src1209217879/src/zazos-web/pages/index.vue")
  },
  {
    name: "login___en",
    path: "/en/login",
    component: () => import("/codebuild/output/src1209217879/src/zazos-web/pages/login/index.vue")
  },
  {
    name: "login___pt",
    path: "/login",
    component: () => import("/codebuild/output/src1209217879/src/zazos-web/pages/login/index.vue")
  },
  {
    name: "set-workspace___en",
    path: "/en/set-workspace",
    component: () => import("/codebuild/output/src1209217879/src/zazos-web/pages/set-workspace.vue")
  },
  {
    name: "set-workspace___pt",
    path: "/set-workspace",
    component: () => import("/codebuild/output/src1209217879/src/zazos-web/pages/set-workspace.vue")
  },
  {
    name: "sign-up___en",
    path: "/en/sign-up",
    component: () => import("/codebuild/output/src1209217879/src/zazos-web/pages/sign-up/index.vue")
  },
  {
    name: "sign-up___pt",
    path: "/sign-up",
    component: () => import("/codebuild/output/src1209217879/src/zazos-web/pages/sign-up/index.vue")
  },
  {
    name: "magic-link___en",
    path: "/en/magic-link",
    component: () => import("/codebuild/output/src1209217879/src/zazos-web/pages/magic-link/index.vue")
  },
  {
    name: "magic-link___pt",
    path: "/magic-link",
    component: () => import("/codebuild/output/src1209217879/src/zazos-web/pages/magic-link/index.vue")
  },
  {
    name: mTibwoLj6aNzFLTlPwnvmQHA8OJJqpgre00S_QxQeD7AMeta?.name,
    path: "/en/t/:tenantSlug()/m",
    meta: mTibwoLj6aNzFLTlPwnvmQHA8OJJqpgre00S_QxQeD7AMeta || {},
    component: () => import("/codebuild/output/src1209217879/src/zazos-web/pages/t/[tenantSlug]/m.vue"),
    children: [
  {
    name: "t-tenantSlug-m___en",
    path: "",
    meta: indexMN9A0xB7oVy5HHBQA3EQBE4CBHkfK8_YOMgsEu6kh5EMeta || {},
    component: () => import("/codebuild/output/src1209217879/src/zazos-web/pages/t/[tenantSlug]/m/index.vue")
  },
  {
    name: "t-tenantSlug-m-viewId___en",
    path: ":viewId()",
    meta: indexjxfMYrRtkQatPba6Tc_45KEkjoG5rLyodTg60WjUZZZBIMeta || {},
    component: () => import("/codebuild/output/src1209217879/src/zazos-web/pages/t/[tenantSlug]/m/[viewId]/index.vue")
  },
  {
    name: "t-tenantSlug-m-viewId-r-new___en",
    path: ":viewId()/r/new",
    meta: newIGbSdZxR4dkVm_1TKWvQVNY3qTFRjJe7jhaLs0vbohgMeta || {},
    component: () => import("/codebuild/output/src1209217879/src/zazos-web/pages/t/[tenantSlug]/m/[viewId]/r/new.vue")
  },
  {
    name: "t-tenantSlug-m-account-configuration___en",
    path: "account-configuration",
    meta: account_45configurationE1OWhjOkMSDAIERvSeHtiQctf3sIzH8r9fE_D3w0X8wMeta || {},
    component: () => import("/codebuild/output/src1209217879/src/zazos-web/pages/t/[tenantSlug]/m/account-configuration.vue")
  },
  {
    name: "t-tenantSlug-m-viewId-r-recordId___en",
    path: ":viewId()/r/:recordId()",
    meta: index50FQpVPrmguhNaYAXyO1WljXaLD4ycJWsc2IsY8V01wMeta || {},
    component: () => import("/codebuild/output/src1209217879/src/zazos-web/pages/t/[tenantSlug]/m/[viewId]/r/[recordId]/index.vue")
  }
]
  },
  {
    name: mTibwoLj6aNzFLTlPwnvmQHA8OJJqpgre00S_QxQeD7AMeta?.name,
    path: "/t/:tenantSlug()/m",
    meta: mTibwoLj6aNzFLTlPwnvmQHA8OJJqpgre00S_QxQeD7AMeta || {},
    component: () => import("/codebuild/output/src1209217879/src/zazos-web/pages/t/[tenantSlug]/m.vue"),
    children: [
  {
    name: "t-tenantSlug-m___pt",
    path: "",
    meta: indexMN9A0xB7oVy5HHBQA3EQBE4CBHkfK8_YOMgsEu6kh5EMeta || {},
    component: () => import("/codebuild/output/src1209217879/src/zazos-web/pages/t/[tenantSlug]/m/index.vue")
  },
  {
    name: "t-tenantSlug-m-viewId___pt",
    path: ":viewId()",
    meta: indexjxfMYrRtkQatPba6Tc_45KEkjoG5rLyodTg60WjUZZZBIMeta || {},
    component: () => import("/codebuild/output/src1209217879/src/zazos-web/pages/t/[tenantSlug]/m/[viewId]/index.vue")
  },
  {
    name: "t-tenantSlug-m-viewId-r-new___pt",
    path: ":viewId()/r/new",
    meta: newIGbSdZxR4dkVm_1TKWvQVNY3qTFRjJe7jhaLs0vbohgMeta || {},
    component: () => import("/codebuild/output/src1209217879/src/zazos-web/pages/t/[tenantSlug]/m/[viewId]/r/new.vue")
  },
  {
    name: "t-tenantSlug-m-account-configuration___pt",
    path: "account-configuration",
    meta: account_45configurationE1OWhjOkMSDAIERvSeHtiQctf3sIzH8r9fE_D3w0X8wMeta || {},
    component: () => import("/codebuild/output/src1209217879/src/zazos-web/pages/t/[tenantSlug]/m/account-configuration.vue")
  },
  {
    name: "t-tenantSlug-m-viewId-r-recordId___pt",
    path: ":viewId()/r/:recordId()",
    meta: index50FQpVPrmguhNaYAXyO1WljXaLD4ycJWsc2IsY8V01wMeta || {},
    component: () => import("/codebuild/output/src1209217879/src/zazos-web/pages/t/[tenantSlug]/m/[viewId]/r/[recordId]/index.vue")
  }
]
  },
  {
    name: "reset-password___en",
    path: "/en/reset-password",
    component: () => import("/codebuild/output/src1209217879/src/zazos-web/pages/reset-password/index.vue")
  },
  {
    name: "reset-password___pt",
    path: "/reset-password",
    component: () => import("/codebuild/output/src1209217879/src/zazos-web/pages/reset-password/index.vue")
  },
  {
    name: "t-tenantSlug___en",
    path: "/en/t/:tenantSlug()",
    meta: indexqDdf3swLYVJt34T_45klzncHoxtnw_Ifpb2wkpYvArb_45YMeta || {},
    component: () => import("/codebuild/output/src1209217879/src/zazos-web/pages/t/[tenantSlug]/index.vue")
  },
  {
    name: "t-tenantSlug___pt",
    path: "/t/:tenantSlug()",
    meta: indexqDdf3swLYVJt34T_45klzncHoxtnw_Ifpb2wkpYvArb_45YMeta || {},
    component: () => import("/codebuild/output/src1209217879/src/zazos-web/pages/t/[tenantSlug]/index.vue")
  },
  {
    name: studiov5o_xyD9LldRiiK1Aq5lbAnAZ_hS3LXilkUYMOZNw7EMeta?.name,
    path: "/en/t/:tenantSlug()/studio",
    meta: studiov5o_xyD9LldRiiK1Aq5lbAnAZ_hS3LXilkUYMOZNw7EMeta || {},
    component: () => import("/codebuild/output/src1209217879/src/zazos-web/pages/t/[tenantSlug]/studio.vue"),
    children: [
  {
    name: "t-tenantSlug-studio___en",
    path: "",
    meta: index7urEnW_453JLCZoL1JdfQpxQOTdJ4So_45cBVA7vg_gWFjEMeta || {},
    component: () => import("/codebuild/output/src1209217879/src/zazos-web/pages/t/[tenantSlug]/studio/index.vue")
  },
  {
    name: settingsr6up_WUy0XMiRyL2VoGU8lclUrZcgB528EKyJSsjel4Meta?.name,
    path: "settings",
    meta: settingsr6up_WUy0XMiRyL2VoGU8lclUrZcgB528EKyJSsjel4Meta || {},
    component: () => import("/codebuild/output/src1209217879/src/zazos-web/pages/t/[tenantSlug]/studio/settings.vue"),
    children: [
  {
    name: "t-tenantSlug-studio-settings___en",
    path: "",
    component: () => import("/codebuild/output/src1209217879/src/zazos-web/pages/t/[tenantSlug]/studio/settings/index.vue")
  },
  {
    name: "t-tenantSlug-studio-settings-user-signup___en",
    path: "user-signup",
    component: () => import("/codebuild/output/src1209217879/src/zazos-web/pages/t/[tenantSlug]/studio/settings/user-signup.vue")
  },
  {
    name: "t-tenantSlug-studio-settings-users___en",
    path: "users",
    component: () => import("/codebuild/output/src1209217879/src/zazos-web/pages/t/[tenantSlug]/studio/settings/users/index.vue")
  },
  {
    name: "t-tenantSlug-studio-settings-tokens___en",
    path: "tokens",
    component: () => import("/codebuild/output/src1209217879/src/zazos-web/pages/t/[tenantSlug]/studio/settings/tokens/index.vue")
  },
  {
    name: "t-tenantSlug-studio-settings-internal___en",
    path: "internal",
    component: () => import("/codebuild/output/src1209217879/src/zazos-web/pages/t/[tenantSlug]/studio/settings/internal/index.vue")
  },
  {
    name: "t-tenantSlug-studio-settings-user-groups-new___en",
    path: "user-groups/new",
    component: () => import("/codebuild/output/src1209217879/src/zazos-web/pages/t/[tenantSlug]/studio/settings/user-groups/new.vue")
  },
  {
    name: "t-tenantSlug-studio-settings-user-groups-id___en",
    path: "user-groups/:id()",
    component: () => import("/codebuild/output/src1209217879/src/zazos-web/pages/t/[tenantSlug]/studio/settings/user-groups/[id].vue")
  },
  {
    name: "t-tenantSlug-studio-settings-app-builder___en",
    path: "app-builder",
    component: () => import("/codebuild/output/src1209217879/src/zazos-web/pages/t/[tenantSlug]/studio/settings/app-builder/index.vue")
  },
  {
    name: "t-tenantSlug-studio-settings-export-data___en",
    path: "export-data",
    component: () => import("/codebuild/output/src1209217879/src/zazos-web/pages/t/[tenantSlug]/studio/settings/export-data/index.vue")
  },
  {
    name: "t-tenantSlug-studio-settings-user-groups___en",
    path: "user-groups",
    component: () => import("/codebuild/output/src1209217879/src/zazos-web/pages/t/[tenantSlug]/studio/settings/user-groups/index.vue")
  },
  {
    name: "t-tenantSlug-studio-settings-integrations___en",
    path: "integrations",
    component: () => import("/codebuild/output/src1209217879/src/zazos-web/pages/t/[tenantSlug]/studio/settings/integrations/index.vue")
  },
  {
    name: "t-tenantSlug-studio-settings-authentication___en",
    path: "authentication",
    component: () => import("/codebuild/output/src1209217879/src/zazos-web/pages/t/[tenantSlug]/studio/settings/authentication/index.vue")
  },
  {
    name: "t-tenantSlug-studio-settings-email-analytics___en",
    path: "email-analytics",
    component: () => import("/codebuild/output/src1209217879/src/zazos-web/pages/t/[tenantSlug]/studio/settings/email-analytics/index.vue")
  },
  {
    name: "t-tenantSlug-studio-settings-system-entities___en",
    path: "system-entities",
    component: () => import("/codebuild/output/src1209217879/src/zazos-web/pages/t/[tenantSlug]/studio/settings/system-entities/index.vue")
  },
  {
    name: "t-tenantSlug-studio-settings-integrations-providerSlug___en",
    path: "integrations/:providerSlug()",
    component: () => import("/codebuild/output/src1209217879/src/zazos-web/pages/t/[tenantSlug]/studio/settings/integrations/[providerSlug].vue")
  },
  {
    name: "t-tenantSlug-studio-settings-global-parameters-manager___en",
    path: "global-parameters-manager",
    component: () => import("/codebuild/output/src1209217879/src/zazos-web/pages/t/[tenantSlug]/studio/settings/global-parameters-manager/index.vue")
  }
]
  },
  {
    name: "t-tenantSlug-studio-data___en",
    path: "data",
    meta: indexWKQa1AxMgmTrqCzNwCthRCdTApHZUr9j6rzpUO2cIkIMeta || {},
    component: () => import("/codebuild/output/src1209217879/src/zazos-web/pages/t/[tenantSlug]/studio/data/index.vue")
  },
  {
    name: "t-tenantSlug-studio-pages-id___en",
    path: "pages/:id()",
    meta: _91id_93fwqpHg9kHvM_Ip1ERamo3Y0F54V8mhBWTRcyoAkumCoMeta || {},
    component: () => import("/codebuild/output/src1209217879/src/zazos-web/pages/t/[tenantSlug]/studio/pages/[id].vue")
  },
  {
    name: "t-tenantSlug-studio-pages___en",
    path: "pages",
    meta: indexpde8atSaliiuj6PsPA_bzBY6Y18aE_4hoS3Bl8juHXIMeta || {},
    component: () => import("/codebuild/output/src1209217879/src/zazos-web/pages/t/[tenantSlug]/studio/pages/index.vue")
  },
  {
    name: "t-tenantSlug-studio-data-id___en",
    path: "data/:id()",
    meta: indexQTAc7vpE_455ZB_xKG7tGEKOjwAitQyjpy36WbOTHR39wMeta || {},
    component: () => import("/codebuild/output/src1209217879/src/zazos-web/pages/t/[tenantSlug]/studio/data/[id]/index.vue")
  },
  {
    name: "t-tenantSlug-studio-data-id-import___en",
    path: "data/:id()/import",
    meta: importS_NwRwIMhHKvd6S5JbSaPuC6IySGubZwrJpGKvznQicMeta || {},
    component: () => import("/codebuild/output/src1209217879/src/zazos-web/pages/t/[tenantSlug]/studio/data/[id]/import.vue")
  },
  {
    name: "t-tenantSlug-studio-data-id-schema___en",
    path: "data/:id()/schema",
    meta: schemaz3sH4ts1dYp_RjNWAmbvqAZth_458l9spHkxGQOdO7cZkMeta || {},
    component: () => import("/codebuild/output/src1209217879/src/zazos-web/pages/t/[tenantSlug]/studio/data/[id]/schema.vue")
  },
  {
    name: "t-tenantSlug-studio-automations___en",
    path: "automations",
    meta: indeximGZ_Cq76_Lt52yNMFNs9BlQRZ_45k258pHXrw97OmSXAMeta || {},
    component: () => import("/codebuild/output/src1209217879/src/zazos-web/pages/t/[tenantSlug]/studio/automations/index.vue")
  },
  {
    name: "t-tenantSlug-studio-automations-id___en",
    path: "automations/:id()",
    meta: indexLBs1GUAlGAb45OdjF__45DLDcVVKp6WUI5co7xfZhtflQMeta || {},
    component: () => import("/codebuild/output/src1209217879/src/zazos-web/pages/t/[tenantSlug]/studio/automations/[id]/index.vue")
  },
  {
    name: "t-tenantSlug-studio-automations-id-history___en",
    path: "automations/:id()/history",
    meta: historyMQ5KaA9LyMKOVgseAJ_458kxZymKPvnqfO5NkCm0X8ftIMeta || {},
    component: () => import("/codebuild/output/src1209217879/src/zazos-web/pages/t/[tenantSlug]/studio/automations/[id]/history.vue")
  }
]
  },
  {
    name: studiov5o_xyD9LldRiiK1Aq5lbAnAZ_hS3LXilkUYMOZNw7EMeta?.name,
    path: "/t/:tenantSlug()/studio",
    meta: studiov5o_xyD9LldRiiK1Aq5lbAnAZ_hS3LXilkUYMOZNw7EMeta || {},
    component: () => import("/codebuild/output/src1209217879/src/zazos-web/pages/t/[tenantSlug]/studio.vue"),
    children: [
  {
    name: "t-tenantSlug-studio___pt",
    path: "",
    meta: index7urEnW_453JLCZoL1JdfQpxQOTdJ4So_45cBVA7vg_gWFjEMeta || {},
    component: () => import("/codebuild/output/src1209217879/src/zazos-web/pages/t/[tenantSlug]/studio/index.vue")
  },
  {
    name: settingsr6up_WUy0XMiRyL2VoGU8lclUrZcgB528EKyJSsjel4Meta?.name,
    path: "settings",
    meta: settingsr6up_WUy0XMiRyL2VoGU8lclUrZcgB528EKyJSsjel4Meta || {},
    component: () => import("/codebuild/output/src1209217879/src/zazos-web/pages/t/[tenantSlug]/studio/settings.vue"),
    children: [
  {
    name: "t-tenantSlug-studio-settings___pt",
    path: "",
    component: () => import("/codebuild/output/src1209217879/src/zazos-web/pages/t/[tenantSlug]/studio/settings/index.vue")
  },
  {
    name: "t-tenantSlug-studio-settings-user-signup___pt",
    path: "user-signup",
    component: () => import("/codebuild/output/src1209217879/src/zazos-web/pages/t/[tenantSlug]/studio/settings/user-signup.vue")
  },
  {
    name: "t-tenantSlug-studio-settings-users___pt",
    path: "users",
    component: () => import("/codebuild/output/src1209217879/src/zazos-web/pages/t/[tenantSlug]/studio/settings/users/index.vue")
  },
  {
    name: "t-tenantSlug-studio-settings-tokens___pt",
    path: "tokens",
    component: () => import("/codebuild/output/src1209217879/src/zazos-web/pages/t/[tenantSlug]/studio/settings/tokens/index.vue")
  },
  {
    name: "t-tenantSlug-studio-settings-internal___pt",
    path: "internal",
    component: () => import("/codebuild/output/src1209217879/src/zazos-web/pages/t/[tenantSlug]/studio/settings/internal/index.vue")
  },
  {
    name: "t-tenantSlug-studio-settings-user-groups-new___pt",
    path: "user-groups/new",
    component: () => import("/codebuild/output/src1209217879/src/zazos-web/pages/t/[tenantSlug]/studio/settings/user-groups/new.vue")
  },
  {
    name: "t-tenantSlug-studio-settings-user-groups-id___pt",
    path: "user-groups/:id()",
    component: () => import("/codebuild/output/src1209217879/src/zazos-web/pages/t/[tenantSlug]/studio/settings/user-groups/[id].vue")
  },
  {
    name: "t-tenantSlug-studio-settings-app-builder___pt",
    path: "app-builder",
    component: () => import("/codebuild/output/src1209217879/src/zazos-web/pages/t/[tenantSlug]/studio/settings/app-builder/index.vue")
  },
  {
    name: "t-tenantSlug-studio-settings-export-data___pt",
    path: "export-data",
    component: () => import("/codebuild/output/src1209217879/src/zazos-web/pages/t/[tenantSlug]/studio/settings/export-data/index.vue")
  },
  {
    name: "t-tenantSlug-studio-settings-user-groups___pt",
    path: "user-groups",
    component: () => import("/codebuild/output/src1209217879/src/zazos-web/pages/t/[tenantSlug]/studio/settings/user-groups/index.vue")
  },
  {
    name: "t-tenantSlug-studio-settings-integrations___pt",
    path: "integrations",
    component: () => import("/codebuild/output/src1209217879/src/zazos-web/pages/t/[tenantSlug]/studio/settings/integrations/index.vue")
  },
  {
    name: "t-tenantSlug-studio-settings-authentication___pt",
    path: "authentication",
    component: () => import("/codebuild/output/src1209217879/src/zazos-web/pages/t/[tenantSlug]/studio/settings/authentication/index.vue")
  },
  {
    name: "t-tenantSlug-studio-settings-email-analytics___pt",
    path: "email-analytics",
    component: () => import("/codebuild/output/src1209217879/src/zazos-web/pages/t/[tenantSlug]/studio/settings/email-analytics/index.vue")
  },
  {
    name: "t-tenantSlug-studio-settings-system-entities___pt",
    path: "system-entities",
    component: () => import("/codebuild/output/src1209217879/src/zazos-web/pages/t/[tenantSlug]/studio/settings/system-entities/index.vue")
  },
  {
    name: "t-tenantSlug-studio-settings-integrations-providerSlug___pt",
    path: "integrations/:providerSlug()",
    component: () => import("/codebuild/output/src1209217879/src/zazos-web/pages/t/[tenantSlug]/studio/settings/integrations/[providerSlug].vue")
  },
  {
    name: "t-tenantSlug-studio-settings-global-parameters-manager___pt",
    path: "global-parameters-manager",
    component: () => import("/codebuild/output/src1209217879/src/zazos-web/pages/t/[tenantSlug]/studio/settings/global-parameters-manager/index.vue")
  }
]
  },
  {
    name: "t-tenantSlug-studio-data___pt",
    path: "data",
    meta: indexWKQa1AxMgmTrqCzNwCthRCdTApHZUr9j6rzpUO2cIkIMeta || {},
    component: () => import("/codebuild/output/src1209217879/src/zazos-web/pages/t/[tenantSlug]/studio/data/index.vue")
  },
  {
    name: "t-tenantSlug-studio-pages-id___pt",
    path: "pages/:id()",
    meta: _91id_93fwqpHg9kHvM_Ip1ERamo3Y0F54V8mhBWTRcyoAkumCoMeta || {},
    component: () => import("/codebuild/output/src1209217879/src/zazos-web/pages/t/[tenantSlug]/studio/pages/[id].vue")
  },
  {
    name: "t-tenantSlug-studio-pages___pt",
    path: "pages",
    meta: indexpde8atSaliiuj6PsPA_bzBY6Y18aE_4hoS3Bl8juHXIMeta || {},
    component: () => import("/codebuild/output/src1209217879/src/zazos-web/pages/t/[tenantSlug]/studio/pages/index.vue")
  },
  {
    name: "t-tenantSlug-studio-data-id___pt",
    path: "data/:id()",
    meta: indexQTAc7vpE_455ZB_xKG7tGEKOjwAitQyjpy36WbOTHR39wMeta || {},
    component: () => import("/codebuild/output/src1209217879/src/zazos-web/pages/t/[tenantSlug]/studio/data/[id]/index.vue")
  },
  {
    name: "t-tenantSlug-studio-data-id-import___pt",
    path: "data/:id()/import",
    meta: importS_NwRwIMhHKvd6S5JbSaPuC6IySGubZwrJpGKvznQicMeta || {},
    component: () => import("/codebuild/output/src1209217879/src/zazos-web/pages/t/[tenantSlug]/studio/data/[id]/import.vue")
  },
  {
    name: "t-tenantSlug-studio-data-id-schema___pt",
    path: "data/:id()/schema",
    meta: schemaz3sH4ts1dYp_RjNWAmbvqAZth_458l9spHkxGQOdO7cZkMeta || {},
    component: () => import("/codebuild/output/src1209217879/src/zazos-web/pages/t/[tenantSlug]/studio/data/[id]/schema.vue")
  },
  {
    name: "t-tenantSlug-studio-automations___pt",
    path: "automations",
    meta: indeximGZ_Cq76_Lt52yNMFNs9BlQRZ_45k258pHXrw97OmSXAMeta || {},
    component: () => import("/codebuild/output/src1209217879/src/zazos-web/pages/t/[tenantSlug]/studio/automations/index.vue")
  },
  {
    name: "t-tenantSlug-studio-automations-id___pt",
    path: "automations/:id()",
    meta: indexLBs1GUAlGAb45OdjF__45DLDcVVKp6WUI5co7xfZhtflQMeta || {},
    component: () => import("/codebuild/output/src1209217879/src/zazos-web/pages/t/[tenantSlug]/studio/automations/[id]/index.vue")
  },
  {
    name: "t-tenantSlug-studio-automations-id-history___pt",
    path: "automations/:id()/history",
    meta: historyMQ5KaA9LyMKOVgseAJ_458kxZymKPvnqfO5NkCm0X8ftIMeta || {},
    component: () => import("/codebuild/output/src1209217879/src/zazos-web/pages/t/[tenantSlug]/studio/automations/[id]/history.vue")
  }
]
  },
  {
    name: "t-tenantSlug-p___en",
    path: "/en/t/:tenantSlug()/p",
    meta: indexqC_45WZFkeMPs6vPH5HFC5lQv_KxBfM20utPGtwXaCXEcMeta || {},
    component: () => import("/codebuild/output/src1209217879/src/zazos-web/pages/t/[tenantSlug]/p/index.vue")
  },
  {
    name: "t-tenantSlug-p___pt",
    path: "/t/:tenantSlug()/p",
    meta: indexqC_45WZFkeMPs6vPH5HFC5lQv_KxBfM20utPGtwXaCXEcMeta || {},
    component: () => import("/codebuild/output/src1209217879/src/zazos-web/pages/t/[tenantSlug]/p/index.vue")
  },
  {
    name: "t-tenantSlug-mfa___en",
    path: "/en/t/:tenantSlug()/mfa",
    meta: index3ICLVicQ_gFr31vVbQ0DIeU4XQQmP6J7oSvnOysToDsMeta || {},
    component: () => import("/codebuild/output/src1209217879/src/zazos-web/pages/t/[tenantSlug]/mfa/index.vue")
  },
  {
    name: "t-tenantSlug-mfa___pt",
    path: "/t/:tenantSlug()/mfa",
    meta: index3ICLVicQ_gFr31vVbQ0DIeU4XQQmP6J7oSvnOysToDsMeta || {},
    component: () => import("/codebuild/output/src1209217879/src/zazos-web/pages/t/[tenantSlug]/mfa/index.vue")
  },
  {
    name: "t-tenantSlug-login___en",
    path: "/en/t/:tenantSlug()/login",
    meta: index6k_mimgEnpM6dp8_PbqGmWFDYVH_3_45SjZTV2xFP4AMIMeta || {},
    component: () => import("/codebuild/output/src1209217879/src/zazos-web/pages/t/[tenantSlug]/login/index.vue")
  },
  {
    name: "t-tenantSlug-login___pt",
    path: "/t/:tenantSlug()/login",
    meta: index6k_mimgEnpM6dp8_PbqGmWFDYVH_3_45SjZTV2xFP4AMIMeta || {},
    component: () => import("/codebuild/output/src1209217879/src/zazos-web/pages/t/[tenantSlug]/login/index.vue")
  },
  {
    name: "t-tenantSlug-store___en",
    path: "/en/t/:tenantSlug()/store",
    meta: index8GIW8XcWnxOEQaHOpmucC0lsVTYijBPXshQyOgHggfUMeta || {},
    component: () => import("/codebuild/output/src1209217879/src/zazos-web/pages/t/[tenantSlug]/store/index.vue")
  },
  {
    name: "t-tenantSlug-store___pt",
    path: "/t/:tenantSlug()/store",
    meta: index8GIW8XcWnxOEQaHOpmucC0lsVTYijBPXshQyOgHggfUMeta || {},
    component: () => import("/codebuild/output/src1209217879/src/zazos-web/pages/t/[tenantSlug]/store/index.vue")
  },
  {
    name: "t-tenantSlug-install-app___en",
    path: "/en/t/:tenantSlug()/install/:app()",
    meta: _91app_937OU2ev9Iyqw757sFOxpE1AIHxdOufMkWxvEVqluDh4QMeta || {},
    component: () => import("/codebuild/output/src1209217879/src/zazos-web/pages/t/[tenantSlug]/install/[app].vue")
  },
  {
    name: "t-tenantSlug-install-app___pt",
    path: "/t/:tenantSlug()/install/:app()",
    meta: _91app_937OU2ev9Iyqw757sFOxpE1AIHxdOufMkWxvEVqluDh4QMeta || {},
    component: () => import("/codebuild/output/src1209217879/src/zazos-web/pages/t/[tenantSlug]/install/[app].vue")
  },
  {
    name: "t-tenantSlug-loading___en",
    path: "/en/t/:tenantSlug()/loading",
    component: () => import("/codebuild/output/src1209217879/src/zazos-web/pages/t/[tenantSlug]/loading/index.vue")
  },
  {
    name: "t-tenantSlug-loading___pt",
    path: "/t/:tenantSlug()/loading",
    component: () => import("/codebuild/output/src1209217879/src/zazos-web/pages/t/[tenantSlug]/loading/index.vue")
  },
  {
    name: "t-tenantSlug-sign-up___en",
    path: "/en/t/:tenantSlug()/sign-up",
    meta: index8fmkW7b9jnm7mz52NUJTKaQOgg3zAqRiJl9l1cjCpIwMeta || {},
    component: () => import("/codebuild/output/src1209217879/src/zazos-web/pages/t/[tenantSlug]/sign-up/index.vue")
  },
  {
    name: "t-tenantSlug-sign-up___pt",
    path: "/t/:tenantSlug()/sign-up",
    meta: index8fmkW7b9jnm7mz52NUJTKaQOgg3zAqRiJl9l1cjCpIwMeta || {},
    component: () => import("/codebuild/output/src1209217879/src/zazos-web/pages/t/[tenantSlug]/sign-up/index.vue")
  },
  {
    name: "t-tenantSlug-reset-password___en",
    path: "/en/t/:tenantSlug()/reset-password",
    meta: reset_45password40TLFf3FjNw9ksarMo51_45PD961D5cMPCPGbGiq1Ozd0Meta || {},
    component: () => import("/codebuild/output/src1209217879/src/zazos-web/pages/t/[tenantSlug]/reset-password.vue")
  },
  {
    name: "t-tenantSlug-reset-password___pt",
    path: "/t/:tenantSlug()/reset-password",
    meta: reset_45password40TLFf3FjNw9ksarMo51_45PD961D5cMPCPGbGiq1Ozd0Meta || {},
    component: () => import("/codebuild/output/src1209217879/src/zazos-web/pages/t/[tenantSlug]/reset-password.vue")
  },
  {
    name: "t-tenantSlug-sso-saml___en",
    path: "/en/t/:tenantSlug()/sso/saml",
    meta: indexzEnj68N0rjiByVXJD0WKamEt6qSIcR0gw5osz02wFdAMeta || {},
    component: () => import("/codebuild/output/src1209217879/src/zazos-web/pages/t/[tenantSlug]/sso/saml/index.vue")
  },
  {
    name: "t-tenantSlug-sso-saml___pt",
    path: "/t/:tenantSlug()/sso/saml",
    meta: indexzEnj68N0rjiByVXJD0WKamEt6qSIcR0gw5osz02wFdAMeta || {},
    component: () => import("/codebuild/output/src1209217879/src/zazos-web/pages/t/[tenantSlug]/sso/saml/index.vue")
  },
  {
    name: "t-tenantSlug-mfa-setup___en",
    path: "/en/t/:tenantSlug()/mfa/setup",
    component: () => import("/codebuild/output/src1209217879/src/zazos-web/pages/t/[tenantSlug]/mfa/setup/index.vue")
  },
  {
    name: "t-tenantSlug-mfa-setup___pt",
    path: "/t/:tenantSlug()/mfa/setup",
    component: () => import("/codebuild/output/src1209217879/src/zazos-web/pages/t/[tenantSlug]/mfa/setup/index.vue")
  },
  {
    name: "t-tenantSlug-p-viewId___en",
    path: "/en/t/:tenantSlug()/p/:viewId()",
    meta: indexWOmcwDgSF2a12WxPEPBbzv2UdN0E_3noeGJ3cR2IrIAMeta || {},
    component: () => import("/codebuild/output/src1209217879/src/zazos-web/pages/t/[tenantSlug]/p/[viewId]/index.vue")
  },
  {
    name: "t-tenantSlug-p-viewId___pt",
    path: "/t/:tenantSlug()/p/:viewId()",
    meta: indexWOmcwDgSF2a12WxPEPBbzv2UdN0E_3noeGJ3cR2IrIAMeta || {},
    component: () => import("/codebuild/output/src1209217879/src/zazos-web/pages/t/[tenantSlug]/p/[viewId]/index.vue")
  },
  {
    name: "t-tenantSlug-store-apps-appName___en",
    path: "/en/t/:tenantSlug()/store/apps/:appName()",
    meta: _91appName_93g0MfvHqhCI4ILPPRLehvxttp0vvteA6HcPR_5VxHoF4Meta || {},
    component: () => import("/codebuild/output/src1209217879/src/zazos-web/pages/t/[tenantSlug]/store/apps/[appName].vue")
  },
  {
    name: "t-tenantSlug-store-apps-appName___pt",
    path: "/t/:tenantSlug()/store/apps/:appName()",
    meta: _91appName_93g0MfvHqhCI4ILPPRLehvxttp0vvteA6HcPR_5VxHoF4Meta || {},
    component: () => import("/codebuild/output/src1209217879/src/zazos-web/pages/t/[tenantSlug]/store/apps/[appName].vue")
  },
  {
    name: "t-tenantSlug-install--review___en",
    path: "/en/t/:tenantSlug()/install/-review",
    component: () => import("/codebuild/output/src1209217879/src/zazos-web/pages/t/[tenantSlug]/install/-review/index.vue")
  },
  {
    name: "t-tenantSlug-install--review___pt",
    path: "/t/:tenantSlug()/install/-review",
    component: () => import("/codebuild/output/src1209217879/src/zazos-web/pages/t/[tenantSlug]/install/-review/index.vue")
  },
  {
    name: "t-tenantSlug-email-validation___en",
    path: "/en/t/:tenantSlug()/email-validation",
    meta: indexvYOa3CXosubg6hXdZgNCg27jpqeTfZvDiejDnq_45QBIcMeta || {},
    component: () => import("/codebuild/output/src1209217879/src/zazos-web/pages/t/[tenantSlug]/email-validation/index.vue")
  },
  {
    name: "t-tenantSlug-email-validation___pt",
    path: "/t/:tenantSlug()/email-validation",
    meta: indexvYOa3CXosubg6hXdZgNCg27jpqeTfZvDiejDnq_45QBIcMeta || {},
    component: () => import("/codebuild/output/src1209217879/src/zazos-web/pages/t/[tenantSlug]/email-validation/index.vue")
  },
  {
    name: "t-tenantSlug-p-viewId-r-recordId___en",
    path: "/en/t/:tenantSlug()/p/:viewId()/r/:recordId()",
    meta: indexD0k_456D9ab5fn9avCIbTgY91x0JmsoF0sxpDYPjbxZ5kMeta || {},
    component: () => import("/codebuild/output/src1209217879/src/zazos-web/pages/t/[tenantSlug]/p/[viewId]/r/[recordId]/index.vue")
  },
  {
    name: "t-tenantSlug-p-viewId-r-recordId___pt",
    path: "/t/:tenantSlug()/p/:viewId()/r/:recordId()",
    meta: indexD0k_456D9ab5fn9avCIbTgY91x0JmsoF0sxpDYPjbxZ5kMeta || {},
    component: () => import("/codebuild/output/src1209217879/src/zazos-web/pages/t/[tenantSlug]/p/[viewId]/r/[recordId]/index.vue")
  }
]